// libraries
import React from 'react';
import PropTypes from 'prop-types';
import {map} from 'lodash';
import {Link} from 'react-router-dom';

// shared
import RadioButton from 'shared/components/radio-button';

export default class SchoolList extends React.Component {
  static propTypes = {
    schools: PropTypes.arrayOf(PropTypes.shape({
      _id: PropTypes.string,
      name: PropTypes.string
    })).isRequired
  }

  state = {
    school: ''
  }

  render() {
    if (this.props.schools.length < 1) return null;

    return (
      <React.Fragment>
        <ul className="auth-school-list">
          {map(this.props.schools, ({name}, i) => (
            <li key={i} className="auth-school-list-item">
              <RadioButton
                name="eligible-school"
                label={name}
                onSelect={() => this.setState({school: name})}
                selected={this.state.school === name}
              />
            </li>
          ))}
        </ul>
        {this.state.school &&
          <Link to="/signup" className="auth-eligibility-eligible-button">
            You&#39;re Eligible! Continue
          </Link>
        }
      </React.Fragment>
    );
  }
}
